import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalNotificationsProvider } from '../global-notifications/global-notifications';

/*
  Generated class for the IntervalServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IntervalServiceProvider {
  interval: any = null;

  constructor(
    public http: HttpClient,
    public globalNotifications: GlobalNotificationsProvider
  ) {
  }

  intervalInit() {
    if (this.interval == null || this.interval == undefined) {
      this.interval = Observable.interval(5000).subscribe(x => {
        this.globalNotifications
          .checkNewMessages()
          .subscribe((response: any) => {
            for (const message of response) {
              this.globalNotifications.notificationActions(message);
            }
          });
      });
    }
  }

  clearInterval() {
    if (this.interval) {
      this.interval.unsubscribe();
      this.interval = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/interval-service/interval-service.ts